<template>
  <b-row class="align-items-end">
    <b-col md="5" sm="12">
      <b-form-group label="Start Date" class="mb-0">
        <flat-pickr v-model="data.from.value" class="form-control" />
      </b-form-group>
    </b-col>
    <b-col md="4" sm="12">
      <b-form-group label="End Date" class="mb-0">
        <flat-pickr v-model="data.to.value" class="form-control" />
      </b-form-group>
    </b-col>
    <b-col md="3" sm="12" class="d-flex gap-2 mt-2 mt-md-0">
      <b-button 
        @click="emitFilter" 
        variant="danger"
        class="flex-grow-1"
      >
        Filter
      </b-button>

      <b-button 
        @click="emitExport" 
        variant="danger"
        class="flex-grow-1"
      >
        Export
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { 
  BLink,
  BImg,
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BProgress,
  BCardText,
  BDropdown,
  BDropdownItem 
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BLink,
    BImg,
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BProgress,
    BCardText,
    BDropdown,
    BDropdownItem,
    flatPickr
  },
  props: {
    date: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      data: {},
    }
  },
  watch: {
    date: {
      handler(newVal) {
        this.data.from = newVal.from
        this.data.to = newVal.to
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    emitFilter() {
      this.$emit('filter-date')
    },
    emitExport() {
      this.$emit('export')
    }
  }
}
</script>

<style>
.form-control,
.btn {
  height: 38px;
}
.gap-2 > * + * {
  margin-left: 8px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
